import { render, staticRenderFns } from "./purchaseDocument.vue?vue&type=template&id=28e4f284&"
import script from "./purchaseDocument.vue?vue&type=script&lang=js&"
export * from "./purchaseDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports